import React from 'react';

import { useBaoCaoTinhTrangDonHangMua } from '@/hooks/queries/useBaoCaoTinhTrangDonHangMua';
import { Button } from '@/components/ui/button';

import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { BasicInfo, DetailsTab, OtherTab } from './tabs';
import { initialValues, searchSchema } from '../schema';

import { useSearchFieldStates } from '../hooks';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: MuaHangRecord) => void;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const searchFieldStates = useSearchFieldStates();
  const { submitBaoCaoTinhTrangDonHangMua } = useBaoCaoTinhTrangDonHangMua();

  const handleFormSubmit = async (data: MuaHangRecord) => {
    const searchFieldData = searchFieldStates.getSearchFieldData();
    const combinedData = {
      ...data,
      ...searchFieldData
    };

    const requestBody = {
      ngay_ct1: combinedData.ngay_ct1 || '',
      ngay_ct2: combinedData.ngay_ct2 || '',
      so_ct1: combinedData.so_ct1 || '',
      so_ct2: combinedData.so_ct2 || '',
      ma_kh: combinedData.ma_kh || '',
      nh_kh1: combinedData.nh_kh1 || '',
      nh_kh2: combinedData.nh_kh2 || '',
      nh_kh3: combinedData.nh_kh3 || '',
      ma_vt: combinedData.ma_vt || '',
      ma_lvt: combinedData.ma_lvt || '',
      nh_vt1: combinedData.nh_vt1 || '',
      nh_vt2: combinedData.nh_vt2 || '',
      nh_vt3: combinedData.nh_vt3 || '',
      ma_kho: combinedData.ma_kho || '',
      ma_lo: combinedData.ma_lo || '',
      ma_vi_tri: combinedData.ma_vi_tri || '',
      ngay_giao: combinedData.ngay_giao || '',
      status: combinedData.status || '',
      dien_giai: combinedData.dien_giai || '',
      ma_gd: combinedData.ma_gd || '',
      mau_bc: parseInt(combinedData.mau_bc || '20'),
      loai_don_hang: combinedData.loai_don_hang || ''
    };

    try {
      await submitBaoCaoTinhTrangDonHangMua(requestBody);
      onSearch(requestBody);
      onClose();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Báo cáo tình trạng đơn hàng mua'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={handleFormSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
            <BasicInfo />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: <DetailsTab searchFieldStates={searchFieldStates} />
                },
                {
                  id: 'other',
                  label: 'Khác',
                  component: <OtherTab searchFieldStates={searchFieldStates} />
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 onClose={onClose} mode='search' submitTitle='Đồng ý' />}
      />
    </DialogV2>
  );
};

export default InitialSearchDialog;
